import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PARAMETER} from '../../constants';

export default {
  id: 'GESTION_USER',
  title: 'Come posso aggiungere o rimuovere utenti alla mia azienda?',
  description: '',
  categories: [CONTENT_CATEGORY_PARAMETER],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Per farlo, fai clic sulla scheda «Parametri» e quindi «Utenti». Troverai l\'elenco degli utenti presenti in questa azienda. Tutti gli utenti della società possono vedere questo elenco e i diversi ruoli. Da sapere che solo l\'Account Manager può gestire le aggiunte e le cancellazioni degli utenti.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Per aggiungere un utente alla tua azienda.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Vai alle impostazioni della tua azienda e alla scheda «Utenti».'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_GESTION_USER/IT_GESTION_USER_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Verificare di avere credito rimanente quindi fare clic su «Aggiungere un utente»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_GESTION_USER/IT_GESTION_USER_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Inserisci l\'indirizzo e-mail, cognome, nome e numero di telefono'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_GESTION_USER/IT_GESTION_USER_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'E poi lo confermi!'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_GESTION_USER/IT_GESTION_USER_4.png`
  }]
};
